module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerBlackItalic.bc9763df.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerBlackItalic.otf
// module id = 1059
// module chunks = 0